export default __webpack_public_path__ + "static/media/banner-phone-nl.ffaa589e.png";